export default __webpack_public_path__ + "static/media/open-eye.f3d45985.svg";